import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Card, Col, Flex, message, Row, Tooltip } from 'antd';
import FilterPanel from '../../components/common/filterPanel';
import RegulationsKPIPanel from '../../components/regulations/regulationsKPIPanel';
import { PlayCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { getRegLibFilterSectionData, updateAppliedSavedFilters, } from '../../services/regulationService';
import mdmService from '../../services/MDMService';
import RegulationsDetailCardList from '../../components/regulations/regulationsDetailCardList';
import { convertSelFilterValToLuObj } from '../../utils/commonUtil';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FloatingOptions from "../../components/common/floatingOptions";
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
function Regulations() {
    var _a, _b, _c, _d;
    const applicationData = useSelector((state) => state.applicationData);
    const [selMainSubProdList, setSelMainSubProdList] = useState([]);
    const [selRegCountryList, setSelRegCountryList] = useState([]);
    const [selDocStatusList, setSelDocStatusList] = useState([]);
    const [selServiceTypeList, setSelServiceTypeList] = useState([]);
    const [isUpdatedInLastwoMonth, setIsUpdatedInLastwoMonth] = useState(false);
    const [isValidCertLinked, setIsValidCertLinked] = useState(false);
    const [totalRegLibCount, setTotalRegLibCount] = useState(-1);
    const [regLibDataList, setRegLibDataList] = useState(new Array(10).fill({}));
    const [regLibKPIData, setRegLibKPIData] = useState();
    const [searchStr, setSearchStr] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [firstPage, setFirstPage] = useState(0);
    const [lastPage, setLastPage] = useState(10);
    const [saveLoading, setSaveLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isDataInitialized, setIsDataInitialized] = useState(false);
    const [isClearFilterSearch, setIsClearFilterSearch] = useState(false);
    const [isKpiSearch, setIsKpiSearch] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [loadDependenciesCounter, setLoadDependenciesCounter] = useState(0);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const getRegLibFilterObj = {
        lstProductTypes: convertSelFilterValToLuObj(selMainSubProdList),
        lstCountry: convertSelFilterValToLuObj(selRegCountryList),
        lstObjLuStatus: convertSelFilterValToLuObj(selDocStatusList),
        intFirstPage: firstPage,
        intPageSize: lastPage,
        strUserId: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId,
        intCompanyID: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID,
        strSearch: searchStr,
        lstLuCompany: applicationData.selClientList,
        boolIsSavedFilterSearch: false,
        boolIsUpdatedInLastwoMonth: isUpdatedInLastwoMonth,
        boolIsValidCertLinked: isValidCertLinked
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (isFirstLoad) {
            const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 5)) != undefined;
            if (!((_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _e === void 0 ? void 0 : _e.boolRegulationLibrayOverviewPageViewAndSearch) || !boolScreenAccessCheck) {
                navigate('/no-access');
                return;
            }
            else if ((_g = (_f = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _f === void 0 ? void 0 : _f.userLoginDetails) === null || _g === void 0 ? void 0 : _g.strUserEmailId) {
                commonService
                    .logUserActivity((_j = (_h = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _h === void 0 ? void 0 : _h.userLoginDetails) === null || _j === void 0 ? void 0 : _j.strUserEmailId, UserActivity.CP__RegLibDashboard_Visited);
            }
        }
    }, [isFirstLoad]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (isFirstLoad) {
            setIsDataInitialized(false);
            setLoadDependenciesCounter(0);
            setRegLibDataList(new Array(10).fill({}));
            setTotalRegLibCount(-1);
            updateAppliedSavedFilters({
                intCompanyID: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
                strUserId: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId,
            }).then((res) => {
                var _a, _b, _c, _d, _e, _f;
                setSelRegCountryList(res[0]);
                setSelMainSubProdList(res[1]);
                setSelServiceTypeList(res[2]);
                let regLibFilterObj = {
                    lstProductTypes: convertSelFilterValToLuObj(res[1]),
                    lstCountry: convertSelFilterValToLuObj(res[0]),
                    intFirstPage: 0,
                    intPageSize: 10,
                    strUserId: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmail,
                    intCompanyID: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID,
                    lstLuCompany: applicationData.selClientList
                };
                mdmService.getDashRegLibraryCount(regLibFilterObj)
                    .then((res) => setTotalRegLibCount(res))
                    .catch(() => setTotalRegLibCount(0));
                mdmService.getDashListRegulatoryLibrary(regLibFilterObj)
                    .then((res) => setRegLibDataList(formatAccessList(res, applicationData)));
                commonService
                    .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Search);
            }).catch((res) => {
                var _a, _b, _c, _d, _e, _f;
                let regLibFilterObj = {
                    intFirstPage: 0,
                    intPageSize: 10,
                    strUserId: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmail,
                    intCompanyID: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID,
                    lstLuCompany: applicationData.selClientList
                };
                mdmService.getDashRegLibraryCount(regLibFilterObj)
                    .then((res) => setTotalRegLibCount(res))
                    .catch(() => setTotalRegLibCount(0));
                mdmService.getDashListRegulatoryLibrary(regLibFilterObj)
                    .then((res) => setRegLibDataList(formatAccessList(res, applicationData)));
                commonService
                    .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Search);
            });
        }
    }, [isFirstLoad]);
    useEffect(() => {
        if (isFirstLoad) {
            setLoadDependenciesCounter(loadDependenciesCounter + 1);
        }
    }, [selRegCountryList]);
    useEffect(() => {
        if (isFirstLoad) {
            setLoadDependenciesCounter(loadDependenciesCounter + 1);
        }
    }, [selMainSubProdList]);
    useEffect(() => {
        if (isFirstLoad && loadDependenciesCounter >= 2) {
            setIsFirstLoad(false);
            setIsDataInitialized(true);
        }
    }, [loadDependenciesCounter]);
    useEffect(() => {
        var _a, _b;
        if (isDataInitialized && !isFirstLoad && !isClearFilterSearch && !isKpiSearch && totalRegLibCount >= 0) {
            setRegLibDataList(new Array(10).fill({}));
            setTotalRegLibCount(-1);
            mdmService.getDashRegLibraryCount(getRegLibFilterObj).then((res) => {
                setTotalRegLibCount(res);
            }).catch((res) => { setTotalRegLibCount(0); });
            ;
            mdmService.getDashListRegulatoryLibrary(getRegLibFilterObj).then((res) => {
                setRegLibDataList(formatAccessList(res, applicationData));
            });
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__RegLibDashboard_Filter_Search);
        }
    }, [isDataInitialized, selRegCountryList, selMainSubProdList, selDocStatusList, firstPage, lastPage, searchStr]);
    useEffect(() => {
        mdmService.getRegLibKPICount(getRegLibFilterObj).then((res) => {
            setRegLibKPIData(res);
        }).catch((e) => {
        });
    }, [applicationData.selClientList]);
    const handleClearAllAppliedFilters = () => {
        var _a, _b, _c, _d, _e, _f;
        setIsClearFilterSearch(true);
        setRegLibDataList(new Array(10).fill({}));
        setTotalRegLibCount(-1);
        setSelMainSubProdList([]);
        setSelRegCountryList([]);
        setSelDocStatusList([]);
        setSelServiceTypeList([]);
        setIsValidCertLinked(false);
        setIsUpdatedInLastwoMonth(false);
        let regLibFilterObj = {
            intFirstPage: 0,
            intPageSize: 10,
            strUserId: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmail,
            intCompanyID: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID,
            lstLuCompany: applicationData.selClientList
        };
        mdmService.getDashRegLibraryCount(regLibFilterObj).then((res) => {
            setTotalRegLibCount(res);
        }).catch((res) => { setTotalRegLibCount(0); });
        mdmService.getDashListRegulatoryLibrary(regLibFilterObj).then((res) => {
            setRegLibDataList(formatAccessList(res, applicationData));
            setCurrentPage(1);
            setFirstPage(0);
            setLastPage(10);
            setIsClearFilterSearch(false);
        });
        commonService
            .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Filter_Search);
    };
    const handleOnPageChange = (currentPage, pageSize) => {
        setRegLibDataList(new Array(10).fill({}));
        setCurrentPage(currentPage);
        setFirstPage(currentPage * pageSize - pageSize);
        setLastPage(currentPage * pageSize);
    };
    const filterSectionData = getRegLibFilterSectionData(applicationData.documentStatusList, selDocStatusList, (val) => setSelDocStatusList(val), applicationData.regionCountryList, selRegCountryList, (val) => setSelRegCountryList(val), applicationData.mainProductTypeList, selMainSubProdList, (val) => setSelMainSubProdList(val), applicationData.serviceTypeList, selServiceTypeList, (val) => setSelServiceTypeList(val), handleClearAllAppliedFilters);
    const handleSaveFilter = () => {
        var _a, _b, _c, _d, _e, _f;
        setSaveLoading(true);
        const objRegulatoryLibFilter = {
            intCompanyID: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
            strUserId: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId,
            lstSelProductTypes: convertSelFilterValToLuObj(selMainSubProdList),
            lstSelRegionCountry: convertSelFilterValToLuObj(selRegCountryList),
            lstObjLuStatus: convertSelFilterValToLuObj(selDocStatusList),
        };
        mdmService.saveRegLibFilter(objRegulatoryLibFilter).then((res) => {
            messageApi.open({
                key: 'Saved_successfully',
                type: 'success',
                content: 'Regulation Library filter saved successfully',
                duration: 3,
            });
            setSaveLoading(false);
            mdmService.getRegLibKPICount(getRegLibFilterObj).then((res) => {
                setRegLibKPIData(res);
            }).catch((e) => {
            });
        });
        commonService
            .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Save_Fav);
    };
    const handleKPIOnClick = (id) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        setIsKpiSearch(true);
        setRegLibDataList(new Array(10).fill({}));
        setTotalRegLibCount(-1);
        setSelMainSubProdList([]);
        setSelRegCountryList([]);
        setSelDocStatusList([]);
        setSelServiceTypeList([]);
        setCurrentPage(1);
        setFirstPage(0);
        setLastPage(10);
        let regLibFilterObj = {
            intFirstPage: 0,
            intPageSize: 10,
            strUserId: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmail,
            intCompanyID: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID,
            strSearch: searchStr,
            lstLuCompany: applicationData.selClientList,
        };
        if (id === 110) {
            let filterObj = Object.assign({ boolIsUpdatedInLastwoMonth: true }, regLibFilterObj);
            setIsUpdatedInLastwoMonth(true);
            mdmService.getDashRegLibraryCount(filterObj).then((res) => {
                setTotalRegLibCount(res);
            }).catch((res) => { setTotalRegLibCount(0); });
            ;
            mdmService.getDashListRegulatoryLibrary(filterObj).then((res) => {
                setRegLibDataList(formatAccessList(res, applicationData));
                setIsKpiSearch(false);
            });
            commonService
                .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Filter_Search);
        }
        if (id === 120) {
            updateAppliedSavedFilters({
                intCompanyID: (_h = (_g = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _g === void 0 ? void 0 : _g.userLoginDetails) === null || _h === void 0 ? void 0 : _h.intCompanyID,
                strUserId: (_k = (_j = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _j === void 0 ? void 0 : _j.userLoginDetails) === null || _k === void 0 ? void 0 : _k.strUserEmailId,
            }).then((res) => {
                var _a, _b;
                let filterObj = Object.assign({ lstProductTypes: convertSelFilterValToLuObj(res[1]), lstCountry: convertSelFilterValToLuObj(res[0]), boolIsUpdatedInLastwoMonth: true }, regLibFilterObj);
                setIsUpdatedInLastwoMonth(true);
                mdmService.getDashRegLibraryCount(filterObj).then((res) => {
                    setTotalRegLibCount(res);
                }).catch((res) => { setTotalRegLibCount(0); });
                ;
                mdmService.getDashListRegulatoryLibrary(filterObj).then((res) => {
                    setRegLibDataList(formatAccessList(res, applicationData));
                    setIsKpiSearch(false);
                });
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__RegLibDashboard_Filter_Search);
            });
        }
        if (id === 130) {
            let filterObj = Object.assign({ boolIsValidCertLinked: true }, regLibFilterObj);
            mdmService.getDashRegLibraryCount(filterObj).then((res) => {
                setTotalRegLibCount(res);
            }).catch((res) => { setTotalRegLibCount(0); });
            ;
            mdmService.getDashListRegulatoryLibrary(filterObj).then((res) => {
                setRegLibDataList(formatAccessList(res, applicationData));
                setIsKpiSearch(false);
            });
            commonService
                .logUserActivity((_m = (_l = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _l === void 0 ? void 0 : _l.userLoginDetails) === null || _m === void 0 ? void 0 : _m.strUserEmailId, UserActivity.CP__RegLibDashboard_Filter_Search);
        }
    };
    return (_jsxs("div", { children: [contextHolder, width <= 1150 &&
                _jsx(FloatingOptions, { data: filterSectionData, extra: _jsxs(Flex, { gap: 'small', justify: 'space-around', children: [_jsx(Button, { shape: "default", icon: _jsx(PlayCircleOutlined, {}), onClick: () => {
                                    var _a, _b;
                                    setIsFirstLoad(true);
                                    commonService
                                        .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__RegLibDashboard_Apply_Fav);
                                }, type: "primary", children: "Apply Saved Filter" }), _jsx(Tooltip, { title: "Save Filter", children: _jsx(Button, { shape: "default", loading: saveLoading, icon: _jsx(SaveOutlined, {}), onClick: () => handleSaveFilter(), type: "primary" }) })] }) }, 'reg_lib_filter_panel'), _jsxs(Row, { gutter: [16, 16], children: [width > 1150 &&
                        _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 6, xl: 5, children: _jsx(FilterPanel, { data: filterSectionData, extra: _jsxs(Flex, { gap: 'small', justify: 'space-around', children: [_jsx(Button, { shape: "default", icon: _jsx(PlayCircleOutlined, {}), onClick: () => setIsFirstLoad(true), type: "primary", children: "Apply Saved Filter" }), _jsx(Tooltip, { title: "Save Filter", children: _jsx(Button, { shape: "default", loading: saveLoading, icon: _jsx(SaveOutlined, {}), onClick: () => handleSaveFilter(), type: "primary" }) })] }) }, 'reg_lib_filter_panel') }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: (width <= 1150) ? 24 : 18, xl: (width <= 1150) ? 24 : 19, children: _jsxs(Row, { gutter: [16, 16], children: [regLibKPIData && regLibKPIData.length > 0 && (_jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(Card, { style: { borderRadius: '0px' }, size: "small", children: _jsx(RegulationsKPIPanel, { data: regLibKPIData, handleKPIOnClick: handleKPIOnClick }) }) })), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(RegulationsDetailCardList, { data: regLibDataList, dataSize: totalRegLibCount, currentPage: currentPage, handleOnPageChange: handleOnPageChange }) })] }) })] })] }));
}
export default Regulations;
//for subscription membership
function formatAccessList(lstRegLib, applicationData) {
    var _a;
    const lstAccessData = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.lstobjAccessScreenCombination;
    const objAccess = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails;
    try {
        lstAccessData.forEach((assc) => {
            lstRegLib.forEach((ldataItem) => {
                var _a, _b, _c;
                const countryMatch = assc.intCountryId !== null &&
                    ((_a = ldataItem === null || ldataItem === void 0 ? void 0 : ldataItem.objLuCountry) === null || _a === void 0 ? void 0 : _a.intId) !== null &&
                    assc.intCountryId === ((_b = ldataItem === null || ldataItem === void 0 ? void 0 : ldataItem.objLuCountry) === null || _b === void 0 ? void 0 : _b.intId);
                const countryAll = objAccess.boolIsAllCountrys;
                if (countryMatch || countryAll) {
                    (_c = ldataItem === null || ldataItem === void 0 ? void 0 : ldataItem.lstProductTypes) === null || _c === void 0 ? void 0 : _c.forEach((product) => {
                        var _a;
                        const productMatch = product.intId !== null &&
                            assc.intProductId !== null &&
                            product.intId === assc.intProductId;
                        const productAll = objAccess.boolIsAllProductTypes;
                        if (productMatch || productAll) {
                            (_a = ldataItem === null || ldataItem === void 0 ? void 0 : ldataItem.lstServiceTypes) === null || _a === void 0 ? void 0 : _a.forEach((service) => {
                                const serviceMatch = service.intId !== null &&
                                    assc.intServiceId !== null &&
                                    service.intId === assc.intServiceId;
                                const serviceAll = objAccess.boolIsAllServiceTypes;
                                if (serviceMatch || serviceAll) {
                                    ldataItem.boolMembershipCombination = true;
                                }
                            });
                        }
                    });
                }
            });
        });
    }
    catch (e) { }
    return lstRegLib;
}
